import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getBlogTags } from '../../data/content';

const BlogTags = () => {
  const tags = useMemo(() => getBlogTags(16), []);

  return (
    <div className="sidebar__single sidebar__tags wow animated fadeInUp" data-wow-delay="0.4s">
      <div className="title">
        <h2>Tags</h2>
      </div>
      <div className="sidebar__tags-list">
        {tags.map((tag) => (
          <Link key={tag} to="/events">
            {tag}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogTags;
